import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import styled from 'styled-components';

export const ProductCardGridContainer = styled.div`
  width: calc(50% - 8px);
  min-width: 160px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;

  > .ant-ribbon-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;

    > div {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }

  .product-image-section {
    min-width: 50px;
    min-height: 50px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      min-width: 50px;
      min-height: 187px;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .product-card-price {
    .price-info {
      margin-top: 0;
      align-items: flex-end;
      flex: 1 !important;
    }

    .price-display {
      align-items: flex-end;
      margin-top: 0;
      width: max-content;
    }

    .price-container {
      display: flex;
      flex-direction: column;
    }
  }

  @media (max-width: 600px) {
    .product-card-price {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .price-info {
        margin-top: 0;
        align-items: flex-start;
        flex: 1 !important;
        flex-direction: row;
      }

      .price-label {
        align-self: center;
      }

      .price-display {
        align-items: flex-start;
        margin-top: 0;
        width: fit-content;
      }

      .price-container {
        display: flex;
        flex-direction: column;
        width: auto;
      }
    }
  }

  .offer-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > :first-child {
      flex: 0 0 auto;
    }

    > :last-child {
      flex: 1 1 auto;
      text-align: right;
      margin-left: 8px;
    }
  }

  @media (max-width: 600px) {
    .offer-header-row {
      > :last-child {
        display: none;
      }
    }

    .product-quality-producer {
      .quality-label,
      .producer-label {
        display: none;
      }
    }

    .product-card-price {
      .freight-text {
        display: none;
      }
    }
  }

  .product-quality-producer {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    text-align: left;
    gap: 8px;

    @media (min-width: ${BREAKPOINTS.tabletMini}) {
      gap: 12px;
    }

    > :first-child {
      flex: 0 0 auto;
      text-align: left;
    }

    > :last-child {
      flex: 1 1 auto;
      text-align: right;
    }
  }

  @media (max-width: 768px) {
    max-width: 400px;
  }

  @media (min-width: 1200px) {
    width: calc(50% - 8px);
    max-width: 300px;

    .product-image-section {
      width: 248px;
      height: 248px;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }
    }

    .product-card-price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;

      > :first-child {
        flex: 1 1 auto;
        text-align: left;
      }

      > :last-child {
        flex: 0 0 auto;
      }
    }

    .price-info {
      .price-display {
        gap: 0;
      }

      .price-value {
        font-size: 20px !important;
      }
    }
  }
`;

export const ProductImagePlaceholder = styled.div`
  width: 100%;
  height: 188px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
  font-size: 14px;
`;

export const TitleConceptColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;
